import { DEFAULT_PAGE_SIZE } from '@did/constants'
import { useDasBalanceContext } from '@did/das-app-context'
import { EnumRecordStatusFilters, UseRecordsType } from '@did/das-balance-types'
import { IDidPointRecord } from '@did/types'
import { useEffect, useState } from 'react'

export const useRecords: UseRecordsType = (balance: string | undefined) => {
  const { services, connectedAccount } = useDasBalanceContext()
  const [currPage, setCurrPage] = useState(1)
  const [total, setTotal] = useState(0)
  const [filter, setFilter] = useState<EnumRecordStatusFilters>(
    EnumRecordStatusFilters.all
  )
  const [recordList, setRecordList] = useState<IDidPointRecord[]>([])
  const pages = Math.ceil(total / DEFAULT_PAGE_SIZE)
  const [loading, setLoading] = useState(true)

  const initData = async (filter: string, page: number) => {
    if (!connectedAccount?.address) {
      setLoading(false)
      return
    }
    try {
      setLoading(true)

      const records = await services.didPoint.didPointRecords({
        key_info: {
          coin_type: connectedAccount.chain?.coinType,
          key: connectedAccount.address
        },
        page: page,
        record_type: filter
      })

      if (!records || !records.list?.length) {
        setRecordList([])
        setTotal(0)
      }

      setRecordList(records.list)
      setTotal(records.total)
    } catch (e: any) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (connectedAccount?.chain?.coinType && connectedAccount?.address) {
      initData(filter, currPage)
    }
  }, [
    currPage,
    filter,
    balance,
    connectedAccount?.chain?.coinType,
    connectedAccount?.address
  ])

  return {
    filter,
    setFilter,
    currPage,
    setCurrPage,
    recordList,
    loading,
    pages
  }
}
